import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
var Dashboard = function () {
    return _jsx(React.Fragment, { children: "Dashboard" });
};
export default Dashboard;
